import React, { FC } from "react";
import "styles/chip.scss";
import { LabelProps } from "types/atoms.types";

const Chip: FC<LabelProps> = ({ option, onRemove }) => {
  return (
    <button className="asr-chip">
      {option.name}
      <span
        className="label-remove-btn"
        onClick={() => onRemove && onRemove(option.id)}
      >
        x
      </span>
    </button>
  );
};

export default Chip;
